module.exports = __webpack_public_path__ + "img/pdf.4a26d5d8.svg";